import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BottomNavDetailsIcon = ({ primaryColor = '#bcbec0', secondaryColor = '#bcbec0', size, style, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 11.98 16.56' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path fill={primaryColor} d='M5.99,6.44c1.78,0,3.22-1.45,3.22-3.22S7.77,0,5.99,0s-3.22,1.44-3.22,3.22,1.45,3.22,3.22,3.22h0Z' />
        <path
            fill={secondaryColor}
            d='M9.51,7c-.06-.04-.15-.03-.19.03-.78,1.06-2.02,1.69-3.33,1.69s-2.55-.63-3.33-1.69c-.04-.06-.13-.07-.19-.03-1.55,1.12-2.47,2.94-2.47,4.84,0,.04,0,4.4.03,4.59,0,.07.07.12.14.12h11.65c.07,0,.13-.05.14-.12.02-.2.03-4.55.03-4.59,0-1.91-.92-3.72-2.47-4.84h0Z'
        />
    </SvgIcon>
);

export default BottomNavDetailsIcon;
